import React from "react";
import { AddedQuestionsSectionProps } from "./types";
import { Button } from "primereact/button";
import { Question } from "../../../interfaces/questions.interface";

const isValidQuestion = (question: any): question is Question => {
  return question 
    && typeof question.questionAnnouncement === 'string'
    && typeof question.answerA === 'string'
    && typeof question.answerB === 'string'
    && typeof question.answerC === 'string'
    && typeof question.answerD === 'string'
    && Array.isArray(question.correctAnswers);
};

export const AddedQuestionsSection: React.FC<AddedQuestionsSectionProps> = ({
  questions,
  onRemoveQuestion,
  onEditQuestion,
}) => {
  const validQuestions = questions?.filter(q => q !== null && isValidQuestion(q)) || [];

  if (validQuestions.length === 0) return null;

  return (
    <div className="space-y-4 max-h-[calc(100vh-400px)] overflow-y-auto pr-2">
      {validQuestions.map((question, index) => (
        <div key={index} className="bg-gray-50 p-4 rounded-lg relative">
          <div className="absolute top-2 right-2 flex gap-2">
            <Button
              icon="pi pi-pencil"
              onClick={() => onEditQuestion(index)}
              className="p-button-text p-button-rounded p-button-info"
              aria-label="Edit question"
            />
            <Button
              icon="pi pi-times-circle"
              onClick={() => onRemoveQuestion(index)}
              className="p-button-text p-button-rounded p-button-danger"
              aria-label="Remove question"
            />
          </div>
          <p className="font-medium">{question.questionAnnouncement}</p>
          <div className="mt-2 space-y-1">
            <p
              className={`text-sm ${
                question.correctAnswers.includes("A")
                  ? "text-green-600 font-medium"
                  : "text-gray-600"
              }`}
            >
              A: {question.answerA}
            </p>
            <p
              className={`text-sm ${
                question.correctAnswers.includes("B")
                  ? "text-green-600 font-medium"
                  : "text-gray-600"
              }`}
            >
              B: {question.answerB}
            </p>
            <p
              className={`text-sm ${
                question.correctAnswers.includes("C")
                  ? "text-green-600 font-medium"
                  : "text-gray-600"
              }`}
            >
              C: {question.answerC}
            </p>
            <p
              className={`text-sm ${
                question.correctAnswers.includes("D")
                  ? "text-green-600 font-medium"
                  : "text-gray-600"
              }`}
            >
              D: {question.answerD}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
